import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';
import { useAuthStore } from '@store/authStore';

export default function LandingPage() {
  const navigate = useNavigate();
  const { checkToken } = useAuthStore();

  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const customEmail = params.get('customEmail');

  useEffect(() => {
    const checkSessionToken = async () => {
      const newPath = await checkToken({ token, customEmail });
      navigate(newPath);
    };

    token && checkSessionToken();
  }, [token]);

  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  );
}
